<template>
  <b-container>
    <b-form-group :disabled="changes_disabled">
      <b-form-group>
        <label>
          <b> {{ $t('table_chosen') }} </b>
        </label>
        <b-form-select v-model="table" :options="table_options" />
      </b-form-group>

      <div v-if="table !== -1">
        <b-card :header="$t('columns_to_delete')">
          <columns-choice-options
            v-model="cols_to_delete"
            :available_column_names="all_columns"
          >
            <template #sub_component="props">
              <generic-column-name-edition
                v-bind="props"
                v-on="props.listeners"
              />
            </template>
          </columns-choice-options>
        </b-card>
        <b-card :header="$t('columns_to_rename')" class="mt-3">
          <columns-choice-options
            v-model="cols_to_rename"
            :available_column_names="all_columns"
            :entry_constructor="generic_column_name_for_renaming_constructor"
          >
            <template #sub_component="props">
              <generic-column-name-edition-for-renaming
                v-bind="props"
                v-on="props.listeners"
              />
            </template>
          </columns-choice-options>
        </b-card>

        <b-card :header="$t('columns_to_copy')" class="mt-3">
          <columns-choice-options
            v-model="cols_to_copy"
            :available_column_names="all_columns"
            :can_reuse_column_names="true"
            :entry_constructor="generic_column_name_for_renaming_constructor"
          >
            <template #sub_component="props">
              <generic-column-name-edition-for-renaming
                v-bind="props"
                v-on="props.listeners"
              />
            </template>
          </columns-choice-options>
        </b-card>
      </div>
    </b-form-group>
  </b-container>
</template>

<i18n>
{
  "en": {
    "new_name": "New name",
    "enter_name": "Enter name",
    "empty_renaming": "The new column name cannot be empty",
    "columns_to_delete": "Columns to delete",
    "columns_to_rename": "Columns to rename",
    "columns_to_copy": "Columns to copy"
  },
  "fr": {
    "new_name": "Nouveau nom",
    "enter_name": "Veuillez rentrer un nom",
    "empty_renaming": "Le nouveau nom de colonne ne peut être vide",
    "columns_to_delete": "Colonnes à supprimer",
    "columns_to_rename": "Colonnes à renommer",
    "columns_to_copy": "Colonnes à copier"
  }
}

</i18n>

<script>
import _ from 'lodash'
import draggable from 'vuedraggable'

import { table_columns } from '@/api/subscriptions.js'

// import {
//   subscription_mixin,
//   brick_mixin,
//   metavariables_tracking_info_mixin,
//   brick_with_single_parent_mixin,
// } from '@/components/mixin.js'
import { global_brick_mixin } from '@/components/mixin.js'
import ColumnsChoiceOptions from './columns_choice_options.vue'
import { GenericColumnNameForRenaming } from '@/components/object_model.js'
import GenericColumnNameEdition from '@/components/generic_column_name_edition.vue'
import GenericColumnNameEditionForRenaming from '@/components/generic_column_name_edition_for_renaming.vue'

// *****************************************************************************

import { BasicTableInfoEntity } from '@/components/object_model.js'

export default {
  name: 'BrickColumnsRenamer',
  components: {
    ColumnsChoiceOptions,
    draggable,
    GenericColumnNameEdition,
    GenericColumnNameEditionForRenaming,
  },
  // mixins: [
  //   subscription_mixin,
  //   brick_mixin,
  //   metavariables_tracking_info_mixin,
  //   brick_with_single_parent_mixin,
  // ],
  mixins: [global_brick_mixin],
  // props: ['brick_id', 'project_id', 'description_name', 'metavariable_dict'],
  data() {
    return {
      table: -1,
      cols_to_delete: [],
      cols_to_rename: [],
      new_col_to_rename: '',
      new_colname_rename: '',
      cols_to_copy: [],
      new_col_to_copy: '',
      new_colname_copy: '',
      all_columns: [],
      left_cols: [],
      right_cols: [],
      editing_name: '',
      editing_nb: -1,
      operations_info: {
        type: 'text',
      },
    }
  },
  computed: {
    adapted_data() {
      let renamed_table_id = []
      if (this.table !== -1) {
        let parent_info_entity_type = new BasicTableInfoEntity()
        parent_info_entity_type.uid = this.table
        renamed_table_id = [parent_info_entity_type]
      }
      let adapted = {
        uid: this.brick_id,
        parents_info: renamed_table_id,
        to_delete: _.cloneDeep(this.cols_to_delete),
        to_rename: _.cloneDeep(this.cols_to_rename),
        to_copy: _.cloneDeep(this.cols_to_copy),
      }

      _.assignIn(adapted, this.description_name)
      return adapted
    },
    generic_column_name_for_renaming_constructor() {
      return GenericColumnNameForRenaming
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(new_val) {
        this.table = (((new_val || {}).parents_info || [])[0] || {}).uid || -1
      },
    },

    table: {
      immediate: true,
      async handler(new_val) {
        this.all_columns =
          (await table_columns(this.project_id, new_val)).pipe_object || []
        this.cols_to_delete = _.cloneDeep(this.cur_brick.to_delete)
        this.cols_to_rename = _.cloneDeep(this.cur_brick.to_rename)
        this.cols_to_copy = _.cloneDeep(this.cur_brick.to_copy)
      },
    },
  },
}
</script>

<!-- <script>
import _ from 'lodash'
import draggable from 'vuedraggable'

import { table_columns } from '@/api/subscriptions.js'

import {
  subscription_mixin,
  brick_mixin,
  metavariables_tracking_info_mixin,
  brick_with_single_parent_mixin,
} from '@/components/aiplatform_mixin.js'
import ColumnsChoiceOptions from './columns_choice_options.vue'
import { GenericColumnNameForRenaming } from '@/components/object_model.js'
import GenericColumnNameEdition from '@/components/generic_column_name_edition.vue'
import GenericColumnNameEditionForRenaming from '@/components/generic_column_name_edition_for_renaming.vue'

// *****************************************************************************

import { BasicTableInfoEntity } from '@/components/object_model.js'

export default {
  name: 'AiplatformColumnsRenamer',
  components: {
    ColumnsChoiceOptions,
    draggable,
    GenericColumnNameEdition,
    GenericColumnNameEditionForRenaming,
  },
  mixins: [
    subscription_mixin,
    brick_mixin,
    metavariables_tracking_info_mixin,
    brick_with_single_parent_mixin,
  ],
  props: ['brick_id', 'project_id', 'description_name', 'metavariable_dict'],
  data() {
    return {
      table: -1,
      cols_to_delete: [],
      cols_to_rename: [],
      new_col_to_rename: '',
      new_colname_rename: '',
      cols_to_copy: [],
      new_col_to_copy: '',
      new_colname_copy: '',
      all_columns: [],
      left_cols: [],
      right_cols: [],
      editing_name: '',
      editing_nb: -1,
      dismiss_secs: 3,
      dismiss_count_down: 0,
      operations_info: {
        type: 'text',
      },
    }
  },
  computed: {
    adapted_data() {
      let renamed_table_id = []
      if (this.table !== -1) {
        let parent_info_entity_type = new BasicTableInfoEntity()
        parent_info_entity_type.uid = this.table
        renamed_table_id = [parent_info_entity_type]
      }
      let adapted = {
        uid: this.brick_id,
        parents_info: renamed_table_id,
        to_delete: this.cols_to_delete,
        to_rename: this.cols_to_rename,
        to_copy: this.cols_to_copy,
      }

      _.assignIn(adapted, this.description_name)
      return adapted
    },
    generic_column_name_for_renaming_constructor() {
      return GenericColumnNameForRenaming
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(new_val) {
        if (new_val.renamings) {
          this.right_cols = _.cloneDeep(new_val.renamings)
          this.table = (new_val.parents_info[0] || {}).uid || -1
        }
      },
    },

    table: {
      immediate: true,
      async handler(new_val) {
        this.all_columns =
          (await table_columns(this.project_id, new_val)).pipe_object || []
        let lhs = _.map(this.all_columns, name => {
          return { name, new_column_name: name }
        })
        this.cols_to_delete = _.cloneDeep(this.cur_brick.to_delete)
        this.cols_to_rename = _.cloneDeep(this.cur_brick.to_rename)
        this.cols_to_copy = _.cloneDeep(this.cur_brick.to_copy)
        this.left_cols = lhs
      },
    },
  },
  methods: {
    add_colrename() {
      this.cols_to_rename.push([
        this.new_colname_rename,
        this.new_col_to_rename,
      ])
      this.new_col_to_rename = ''
      this.new_colname_rename = ''
    },
    reinit_colrename() {
      this.new_col_to_rename = ''
      this.new_colname_rename = ''
    },
    trash_colrename(index) {
      this.cols_to_rename.splice(index, 1)
    },
    add_colcopy() {
      this.cols_to_copy.push([this.new_colname_copy, this.new_col_to_copy])
      this.new_col_to_copy = ''
      this.new_colname_copy = ''
    },
    reinit_colcopy() {
      this.new_col_to_copy = ''
      this.new_colname_copy = ''
    },
    trash_colcopy(index) {
      this.cols_to_copy.splice(index, 1)
    },
    count_down_changed(dismiss_count_down) {
      this.dismiss_count_down = dismiss_count_down
    },
    show_alert_empty_renaming() {
      this.dismiss_count_down = this.dismiss_secs
    },
    clone_column(col) {
      return { name: col.name, new_column_name: col.name }
    },
    select_all() {
      this.right_cols = _.cloneDeep(this.left_cols)
    },
    deselect_all() {
      this.right_cols = []
    },
    toggle_editing(index) {
      if (this.editing_nb === -1) {
        this.editing_nb = index
        let old_new_name = this.right_cols[index].new_column_name
        if (old_new_name) {
          this.editing_name = old_new_name
        }
      } else {
        if (!_.isEmpty(this.editing_name)) {
          this.right_cols[this.editing_nb].new_column_name = this.editing_name
          this.editing_nb = -1
          this.editing_name = ''
        } else {
          // TODO : Alert if renaming is empty
          this.show_alert_empty_renaming()
        }
      }
    },
    delete_col(index) {
      this.right_cols.splice(index, 1)
    },
  },
}
</script>
 -->
